import React, {Component} from 'react';
import './assets/main.scss';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';

import Header from './component/sections/Header';
import Footer from './component/sections/Footer';
import {getCurrentUser} from "./util/api";
import {ACCESS_TOKEN} from "./constatns";

import 'bootstrap/dist/css/bootstrap.min.css';
import {withTranslation} from "react-i18next";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import TermsPage from "./page/Terms";
import PrivacyPolicyPage from "./page/PrivacyPolicy";
import i18next from "i18next";

// import ChatPage from "./page/Chat";
// import ChatRoomPage from "./page/ChatRooms";


class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			authenticated: false,
			currentUser: null
		};

		this.loadCurrentlyLoggedInUser = this.loadCurrentlyLoggedInUser.bind(this);
		this.handleLogout = this.handleLogout.bind(this);

		const lang = (navigator.language || navigator.userLanguage);
		if(lang == 'ko') i18next.changeLanguage('ko').then(r => {});

	}

	loadCurrentlyLoggedInUser() {
		this.setState({
			loading: true
		});

		getCurrentUser().then(response => {
			this.setState({
				currentUser: response,
				authenticated: true,
				loading: false
			});
		}).catch(error => {
			this.setState({
				loading: false
			});
		});
	}

	handleLogout() {
		localStorage.removeItem(ACCESS_TOKEN);
		this.setState({
			authenticated: false,
			currentUser: null
		});
		Alert.success("You're safely logged out!");
	}

	componentDidMount() {
	}

	render() {
		return (
			<BrowserRouter>
			<div>
				<Switch>
					<React.Fragment>
						<Route path={`${process.env.PUBLIC_URL}/terms`} component={TermsPage} />
						<Route path={`${process.env.PUBLIC_URL}/privacy`} component={PrivacyPolicyPage} />
						{/*<Route path={`${process.env.PUBLIC_URL}/chatRoom`} component={ChatRoomPage} />*/}
						{/*<Route path={`${process.env.PUBLIC_URL}/chat`} component={ChatPage} />*/}
						<div>
							{(window.location.pathname !== '/terms' && window.location.pathname !== '/privacy') ? <Header/> : null}
							{(window.location.pathname !== '/terms' && window.location.pathname !== '/privacy') ? <Footer/> : null}
							<Alert stack={{limit: 3}}
										 timeout={3000}
										 position='top-right' effect='slide' offset={65}/>
						</div>
					</React.Fragment>
				</Switch>
			</div>
			</BrowserRouter>
		)
	}
}

// export default App;
export default withTranslation()(App);
